import classNames from 'classnames/bind';
import GeneralIcon, { GENERAL_ICONS } from 'components/GeneralIcon/GeneralIcon';
import LinkBase from 'corecomponents/LinkBase/LinkBase';
import PropTypes from 'prop-types';
import styles from './DisplayPublishedEverywhere.module.css';

const cx = classNames.bind(styles);

const LISTING_SITES = [
  { key: 'zillow', icon: GENERAL_ICONS.ZILLOW },
  { key: 'zumper', icon: GENERAL_ICONS.ZUMPER },
  { key: 'trulia', icon: GENERAL_ICONS.TRULIA },
  { key: 'facebook', icon: GENERAL_ICONS.FACEBOOK_MARKETPLACE },
  { key: 'apartments', icon: GENERAL_ICONS.APARTMENTS_DOT_COM },
  { key: 'mls', icon: GENERAL_ICONS.MLS_LISTINGS },
  { key: 'craigslist', icon: GENERAL_ICONS.CRAIGSLIST },
  { key: 'hotpads', icon: GENERAL_ICONS.HOTPADS },
];

const DisplayPublishedEverywhere = ({ publications }) => {
  const links =
    publications?.externalPublishing?.[0]?.externalListingDetailModels.reduce(
      (linkAccum, currentLink) => {
        if (currentLink.error) {
          return linkAccum;
        }

        return {
          ...linkAccum,
          [currentLink.destination.toLowerCase()]: currentLink.url,
        };
      },
      {},
    );

  return (
    <div className={cx('published-everywhere')}>
      {LISTING_SITES.map(({ key, icon }) => {
        const logo = <GeneralIcon className={cx('listing-icon')} icon={icon} />;
        const url = links?.[key];
        return (
          <div key={key} className={cx('logo')}>
            {url ? (
              <LinkBase target="_blank" to={url}>
                {logo}
              </LinkBase>
            ) : (
              logo
            )}
          </div>
        );
      })}
    </div>
  );
};

DisplayPublishedEverywhere.propTypes = {
  publications: PropTypes.object,
};

export default DisplayPublishedEverywhere;
